import { onLoaded, loadContent } from "@/utils"

// Prevent multiple initializations
let searchInitialized = false

const Search = () => {
    // Prevent re-initialization
    if (searchInitialized) {
        return
    }

    let searchTimeout = null
    const settings = ajaxpress_vars.settings || {}

    onLoaded(() => {
        // Prevent re-initialization
        if (searchInitialized) {
            return
        }

        // Mark as initialized
        searchInitialized = true

        const searchForms = document.querySelectorAll('form[role="search"], .search-form, form.searchform')

        searchForms.forEach(form => {
            const searchInput = form.querySelector('input[type="search"], input[name="s"]')

            if (!searchInput) return

            searchInput.addEventListener('input', (e) => {
                clearTimeout(searchTimeout)

                const query = e.target.value.trim()

                if (query.length < 3) return

                searchTimeout = setTimeout(() => {
                    performSearch(form, query)
                }, 500)
            })

            form.addEventListener('submit', (e) => {
                e.preventDefault()
                const query = searchInput.value.trim()

                if (query.length > 0) {
                    performSearch(form, query)
                }
            })
        })
    })

    const performSearch = async (form, query) => {
        const formData = new FormData(form)
        const params = new URLSearchParams(formData)
        const searchUrl = `${ajaxpress_vars.site.url}/?${params.toString()}`

        await loadContent(searchUrl, 'search')
    }
}

export default Search
